import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock, PackageX } from 'lucide-react';
import apiClient from '@/services/apiClient';

const Chip = ({ to, children, testId }) => (
  <Link to={to} className="rounded border border-rose-200 bg-white px-2 py-0.5 text-[11px] text-rose-800 hover:bg-rose-100 transition-colors" data-testid={testId}>{children}</Link>
);

const Row = ({ icon: Icon, tone, title, testId, children, to, linkTestId }) => (
  <div className={`flex flex-wrap items-start gap-3 rounded-lg border px-4 py-3 ${tone}`} data-testid={testId}>
    <Icon className="h-5 w-5 shrink-0 mt-0.5" />
    <div className="min-w-0 flex-1">
      <p className="text-sm font-semibold">{title}</p>
      <div className="mt-1 flex flex-wrap gap-1.5">{children}</div>
    </div>
    <Link to={to} className="text-xs font-semibold underline underline-offset-2 hover:opacity-80" data-testid={linkTestId}>Show all</Link>
  </div>
);

/** PO list: open POs past their expected delivery date, and received supplier bundles still not counted on a PO line. */
export const PoAlertsBanner = () => {
  const [d, setD] = useState(null);
  useEffect(() => { apiClient.get('/po-followup/alerts').then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d || (!d.late.count && !d.unmapped.deliveries)) return null;
  return (
    <div className="space-y-2" data-testid="po-alerts-banner">
      {d.late.count > 0 && (
        <Row icon={CalendarClock} tone="border-rose-200 bg-rose-50 text-rose-900" testId="po-alert-late" to="/po/follow-up?tab=late" linkTestId="po-alert-late-all"
          title={`${d.late.count} Purchase Order${d.late.count > 1 ? 's are' : ' is'} past the expected delivery date with qty still to come`}>
          {d.late.pos.map((p) => <Chip key={p.po_id} to={`/po/${p.po_id}`} testId={`po-alert-late-chip-${p.po_id}`}>
            <span className="font-mono">{p.po_number}</span> · {p.vendor_name} · {p.days_late}d late</Chip>)}
        </Row>
      )}
      {d.unmapped.deliveries > 0 && (
        <Row icon={PackageX} tone="border-amber-200 bg-amber-50 text-amber-900" testId="po-alert-unmapped" to="/po/follow-up?tab=unmapped" linkTestId="po-alert-unmapped-all"
          title={`${d.unmapped.bundles} received bundle${d.unmapped.bundles > 1 ? 's' : ''} in ${d.unmapped.deliveries} supplier deliver${d.unmapped.deliveries > 1 ? 'ies' : 'y'} not counted on a PO for ${d.unmapped.days}+ days`}>
          {d.unmapped.items.map((u) => <Chip key={u.entry_id} to={u.path} testId={`po-alert-unmapped-chip-${u.entry_id}`}>
            <span className="font-mono">{u.document_barcode || u.entry_id}</span> · {u.section_name} · {u.unassigned_count} bundle{u.unassigned_count > 1 ? 's' : ''}</Chip>)}
        </Row>
      )}
    </div>
  );
};
